import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import { Grid3X3, Grid2X2, LayoutGrid } from "lucide-react";

interface GridLayoutSelectorProps {
  value: number;
  onValueChange: (value: number) => void;
}

export const GridLayoutSelector = ({ value, onValueChange }: GridLayoutSelectorProps) => {
  return (
    <div className="showcase-grid-selector hidden md:flex items-center gap-2">
      <span className="text-sm text-muted-foreground">Columns:</span>
      <ToggleGroup 
        type="single" 
        value={value.toString()} 
        onValueChange={(newValue) => newValue && onValueChange(Number(newValue))}
        className="border border-border bg-component-background rounded-md p-1"
      >
        <ToggleGroupItem value="3" aria-label="3 columns" size="sm">
          <Grid2X2 className="h-4 w-4" />
          <span className="ml-1 text-xs">3</span>
        </ToggleGroupItem>
        <ToggleGroupItem value="4" aria-label="4 columns" size="sm">
          <Grid3X3 className="h-4 w-4" />
          <span className="ml-1 text-xs">4</span>
        </ToggleGroupItem>
        <ToggleGroupItem value="5" aria-label="5 columns" size="sm">
          <LayoutGrid className="h-4 w-4" />
          <span className="ml-1 text-xs">5</span>
        </ToggleGroupItem>
      </ToggleGroup>
    </div>
  );
};